import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const listClass = "list-none space-y-2 text-sm leading-relaxed text-[rgba(245,245,245,0.82)]";
const bullet = "before:mr-2 before:text-[var(--zx-accent)] before:content-['—']";

/** Misma pila que el body (index.css), para títulos exportados vía STEP_TITLES. */
export const STEP_TITLE_FONT_CLASS =
  "[font-family:'Space_Mono',ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,'Liberation_Mono','Courier_New',monospace]";

export const STEP_TITLES = {
  1: "Reglas básicas inquebrantables",
  2: "La Lista no es una aplicación de citas",
  3: "Normas e infracciones",
  4: "Sistema de reputación",
  5: "Acceso al club",
};

function FadeBlock({ children, className = "" }) {
  return <div className={className}>{children}</div>;
}

export function OnboardingStepBody({ step, layout }) {
  const isMobile = layout === "mobile";

  if (step === 1) {
    const rules = [
      "Sin nombres",
      "Sin datos personales",
      "Sin redes sociales",
      "Sin grabar o compartir el encuentro",
      "Sin hablar de trabajo",
      "Sin hablar de rutinas",
      "Sin hablar de nuestras vidas fuera de este entorno",
      "Quien organiza el encuentro, corre con los gastos. Mañana puedes ser tú quien organice.",
    ];
    return (
      <FadeBlock className="space-y-6">
        <ul className={listClass}>
          {rules.map((t) => (
            <li key={t} className={bullet}>
              {t}
            </li>
          ))}
        </ul>
        <p className="border-l-2 border-[var(--zx-accent)]/50 pl-4 text-sm italic text-[rgba(245,245,245,0.72)]">
          Si no entiendes estas reglas básicas, este no es tu lugar.
        </p>
      </FadeBlock>
    );
  }

  if (step === 2) {
    return (
      <FadeBlock className="space-y-5 text-sm leading-relaxed text-[rgba(245,245,245,0.82)]">
        <p>Es un club privado.</p>
        <p>Todos los miembros acceden en igualdad de condiciones.</p>
        <p className="text-[rgba(245,245,245,0.55)]">
          No hay dinámicas externas.
          <br />
          No hay roles.
          <br />
          No hay ventajas.
        </p>
        <p>Formar parte implica una suscripción activa.</p>
      </FadeBlock>
    );
  }

  if (step === 3) {
    const sacred = [
      "Romper anonimato",
      "Hablar de vida personal",
      "Hablar de trabajo",
      "Negociar condiciones",
      "No pagar como organizador",
      "Grabar o compartir",
    ];
    const faults = [
      "Mentir en elperfil",
      "No presentarse al encuentro",
      "Cancelaciones tardías",
      "Incumplimiento de los requisitos delencuentro",
    ];

    const sacredBlock = (
      <>
        <ul className={listClass}>
          {sacred.map((t) => (
            <li key={t} className={bullet}>
              {t}
            </li>
          ))}
        </ul>
        <p className="mt-4 text-xs uppercase tracking-[0.18em] text-[rgba(245,245,245,0.45)]">
          Romper estas reglas implica expulsión inmediata.
        </p>
      </>
    );

    const faultsBlock = (
      <>
        <ul className={listClass}>
          {faults.map((t) => (
            <li key={t} className={bullet}>
              {t}
            </li>
          ))}
        </ul>
        <p className="mt-4 text-xs uppercase tracking-[0.18em] text-[rgba(245,245,245,0.45)]">
          Las faltas generan restricciones progresivas.
        </p>
      </>
    );

    if (isMobile) {
      return (
        <FadeBlock>
          <Accordion type="single" collapsible className="w-full border-none">
            <AccordionItem
              value="sacred"
              className="border border-[rgba(255,255,255,0.1)] rounded-lg px-3 mb-2 bg-[rgba(255,255,255,0.02)]"
            >
              <AccordionTrigger className="font-serif text-base hover:no-underline py-3">
                Reglas básicas (expulsión)
              </AccordionTrigger>
              <AccordionContent className="pb-4">{sacredBlock}</AccordionContent>
            </AccordionItem>
            <AccordionItem
              value="faults"
              className="border border-[rgba(255,255,255,0.1)] rounded-lg px-3 bg-[rgba(255,255,255,0.02)]"
            >
              <AccordionTrigger className="font-serif text-base hover:no-underline py-3">
                Faltas
              </AccordionTrigger>
              <AccordionContent className="pb-4">{faultsBlock}</AccordionContent>
            </AccordionItem>
          </Accordion>
        </FadeBlock>
      );
    }

    return (
      <FadeBlock className="space-y-10">
        <section className="space-y-3">
          <h3 className="font-serif text-lg text-[#f5f5f5]">Reglas básicas (expulsión)</h3>
          {sacredBlock}
        </section>
        <div className="zx-divider opacity-60" />
        <section className="space-y-3">
          <h3 className="font-serif text-lg text-[#f5f5f5]">Faltas</h3>
          {faultsBlock}
        </section>
      </FadeBlock>
    );
  }

  if (step === 4) {
    const intro = (
      <>
        <p className="text-sm leading-relaxed text-[rgba(245,245,245,0.82)]">
          Cada miembro tiene una puntuación máxima de 5 estrellas.
        </p>
        <p className="text-sm leading-relaxed text-[rgba(245,245,245,0.82)]">
          Todos empiezan con la máxima puntuación.
        </p>
        <p className="text-sm leading-relaxed text-[rgba(245,245,245,0.82)]">
          Tu comportamiento define tu acceso dentro del club.
        </p>
      </>
    );

    const evaluationCriteria = (
      <div className="space-y-3 border border-[rgba(255,255,255,0.08)] rounded-lg p-4 bg-[rgba(255,255,255,0.02)] text-sm text-[rgba(245,245,245,0.82)]">
        <p>
          <span className="mr-2">🟢</span>
          Correcto
          <span className="block pl-7 text-[rgba(245,245,245,0.65)] mt-1">
            → +0.25 ⭐
          </span>
        </p>
        <p>
          <span className="mr-2">🟡</span>
          Incidencia leve
          <span className="block pl-7 text-[rgba(245,245,245,0.65)] mt-1">→ -0.5 ⭐</span>
        </p>
        <p>
          <span className="mr-2">🔴</span>
          Incidencia grave
          <span className="block pl-7 text-[rgba(245,245,245,0.65)] mt-1">→ -1.25 ⭐</span>
        </p>
      </div>
    );

    const evaluation = (
      <div className="space-y-4 text-sm text-[rgba(245,245,245,0.82)]">
        <p className="text-xs uppercase tracking-[0.2em] text-[rgba(245,245,245,0.45)]">
          Evaluación tras cada encuentro
        </p>
        {evaluationCriteria}
      </div>
    );

    const consequencesList = (
      <ul className={listClass}>
        <li className={bullet}>5⭐–4.25⭐ → acceso normal</li>
        <li className={bullet}>4⭐–3.25⭐ → leve restricción</li>
        <li className={bullet}>3⭐–2.25⭐ → menor visibilidad</li>
        <li className={bullet}>2⭐–1.25⭐ → acceso limitado</li>
        <li className={bullet}>1⭐–0.25⭐ → acceso limitado y casi fuera</li>
        <li className={bullet}>0⭐ → expulsión</li>
      </ul>
    );

    const consequences = (
      <div className="space-y-3">
        <p className="text-xs uppercase tracking-[0.2em] text-[rgba(245,245,245,0.45)]">
          Consecuencias
        </p>
        {consequencesList}
      </div>
    );

    const closing = (
      <p className="border-l-2 border-[var(--zx-accent)]/50 pl-4 text-sm italic text-[rgba(245,245,245,0.72)]">
        Puedes recuperarte mientras no estés en 0.
      </p>
    );

    if (isMobile) {
      return (
        <FadeBlock className="space-y-6">
          {intro}
          <Accordion type="single" collapsible className="w-full border-none">
            <AccordionItem
              value="eval"
              className="border border-[rgba(255,255,255,0.1)] rounded-lg px-3 mb-2 bg-[rgba(255,255,255,0.02)]"
            >
              <AccordionTrigger className="font-serif text-base hover:no-underline py-3">
                Evaluación tras cada encuentro
              </AccordionTrigger>
              <AccordionContent className="pb-4">{evaluationCriteria}</AccordionContent>
            </AccordionItem>
            <AccordionItem
              value="cons"
              className="border border-[rgba(255,255,255,0.1)] rounded-lg px-3 bg-[rgba(255,255,255,0.02)]"
            >
              <AccordionTrigger className="font-serif text-base hover:no-underline py-3">
                Consecuencias
              </AccordionTrigger>
              <AccordionContent className="pb-4">{consequencesList}</AccordionContent>
            </AccordionItem>
          </Accordion>
          {closing}
        </FadeBlock>
      );
    }

    return (
      <FadeBlock className="space-y-8">
        {intro}
        {evaluation}
        {consequences}
        {closing}
      </FadeBlock>
    );
  }

  if (step === 5) {
    const tiers = [
      {
        name: "Bronze",
        headerClass:
          "border-b border-[#b87333]/35 bg-gradient-to-r from-[#b87333]/18 to-transparent",
        titleClass: "text-[#d4a574]",
        items: ["Ver encuentros", "Se paga por acceder/organizar un encuentro", "Acceso puntual de pago"],
      },
      {
        name: "Plata",
        headerClass:
          "border-b border-[#9aa8b8]/35 bg-gradient-to-r from-[#9aa8b8]/16 to-transparent",
        titleClass: "text-[#c5d0dc]",
        items: [
          "10 encuentros al mes",
          "Máximo de 3 encuentros en el mismo día",
          "Radio limitado",
          "Encuentros acumulables",
        ],
      },
      {
        name: "Oro",
        headerClass:
          "border-b border-[#c9a227]/40 bg-gradient-to-r from-[#c9a227]/18 to-transparent",
        titleClass: "text-[#e8c547]",
        items: [
          "1 encuentro por días que tenga el mes en curso (28, 30 o 31)",
          "Máximo de 3 encuentros en el mismo día",
          "Mayor acceso",
          "Encuentros acumulables",
        ],
      },
      {
        name: "Platino",
        headerClass:
          "border-b border-[#dfe7f2]/25 bg-gradient-to-r from-[#dfe7f2]/12 to-transparent",
        titleClass: "text-[#eef3fb]",
        items: ["Encuentros ilimitados", "Sin límite de distancia"],
      },
    ];

    if (isMobile) {
      return (
        <FadeBlock className="space-y-4">
          <Accordion type="single" collapsible className="w-full border-none">
            {tiers.map((tier) => (
              <AccordionItem
                key={tier.name}
                value={tier.name}
                className="border border-[rgba(255,255,255,0.1)] rounded-lg px-3 mb-2 last:mb-0 bg-[rgba(255,255,255,0.02)]"
              >
                <AccordionTrigger
                  className={[
                    "font-serif text-base font-medium hover:no-underline py-3 px-1 -mx-1 rounded-md transition-colors",
                    tier.headerClass,
                    tier.titleClass,
                  ].join(" ")}
                >
                  {tier.name}
                </AccordionTrigger>
                <AccordionContent className="pb-4">
                  <ul className={listClass}>
                    {tier.items.map((t) => (
                      <li key={t} className={bullet}>
                        {t}
                      </li>
                    ))}
                  </ul>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
          <p className="pt-2 text-sm italic text-[rgba(245,245,245,0.65)]">
            No todos acceden igual. Y eso es parte de la experiencia.
          </p>
        </FadeBlock>
      );
    }

    return (
      <FadeBlock className="space-y-8">
        <div className="grid gap-6 sm:grid-cols-2">
          {tiers.map((tier) => (
            <div
              key={tier.name}
              className="flex flex-col overflow-hidden rounded-xl border border-[rgba(255,255,255,0.1)] bg-[rgba(255,255,255,0.03)]"
            >
              <div className={["px-5 py-4 md:px-6 md:py-4", tier.headerClass].join(" ")}>
                <h3 className={["font-serif text-xl font-medium tracking-tight", tier.titleClass].join(" ")}>
                  {tier.name}
                </h3>
              </div>
              <div className="px-5 pb-5 pt-4 md:px-6">
                <ul className={listClass}>
                  {tier.items.map((t) => (
                    <li key={t} className={bullet}>
                      {t}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
        <p className="text-center text-sm italic text-[rgba(245,245,245,0.65)]">
          No todos acceden igual. Y eso es parte de la experiencia.
        </p>
      </FadeBlock>
    );
  }

  return null;
}

export const ACCEPT_LABELS = {
  1: "He leído y acepto las reglas básicas",
  2: "Entiendo el concepto del club",
  3: "He leído las normas e infracciones",
  4: "Entiendo el sistema de reputación",
  5: "He leído la información de las diferentesmembresías",
};
